import React from "react";
import { useParams } from "react-router-dom";
import { MODULES } from "@/lib/constants";
import { Sparkles } from "lucide-react";
import DJModule from "@/pages/DJModule";
import PhotoboothModule from "@/pages/PhotoboothModule";

export default function ModulePage() {
  const { key } = useParams();
  if (key === "dj") return <DJModule />;
  if (key === "photobooth") return <PhotoboothModule />;
  const mod = MODULES.find((m) => m.key === key);
  const Icon = mod?.icon || Sparkles;
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FF6A00]/15"><Icon className="h-7 w-7 text-[#FF6A00]" strokeWidth={1.6} /></div>
        <div>
          <h1 className="font-display text-3xl font-bold text-white">{mod?.label || "Module"}</h1>
          <p className="mt-1 text-zinc-500">Module métier activé.</p>
        </div>
      </div>
      <div className="rounded-2xl border border-dashed border-zinc-800 bg-zinc-900/40 p-12 text-center">
        <Sparkles className="mx-auto h-10 w-10 text-[#FFD500]" />
        <p className="mt-4 font-display text-xl font-semibold text-white">Bientôt disponible</p>
        <p className="mx-auto mt-2 max-w-md text-zinc-500">
          Ce module (fiches de préparation, checklists, spécificités métier) fait partie de la feuille de route. Le cœur commun — devis, contacts, calendrier, paiements — est déjà pleinement opérationnel.
        </p>
      </div>
    </div>
  );
}
